import React from 'react';

import FenceIcon from '@mui/icons-material/Fence';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import RouteIcon from '@mui/icons-material/Route';
import { Box, IconButton, Stack, Tooltip, Typography } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import { missionPlannerStore, type PlannerMode } from '../../stores/MissionPlannerStore';

// A reusable component for the mode selection buttons
const ModeButton = observer(({ mode, label, icon }: { mode: PlannerMode; label: string; icon: React.ReactNode }) => {
  const isActive = missionPlannerStore.mode === mode;
  return (
    <Tooltip title={label} placement='right'>
      <IconButton
        variant={isActive ? 'solid' : 'plain'}
        color={isActive ? 'primary' : 'neutral'}
        onClick={() => missionPlannerStore.setMode(mode)}
        sx={{
          flexDirection: 'column',
          height: 'auto',
          p: 1
        }}
      >
        {icon}
        <Typography level='body-xs'>{label}</Typography>
      </IconButton>
    </Tooltip>
  );
});

const ToolsPanel: React.FC = () => (
  <Box sx={{ p: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
    <Stack spacing={2}>
      <ModeButton mode='Mission' label='Mission' icon={<RouteIcon />} />
      <ModeButton mode='GeoFence' label='GeoFence' icon={<FenceIcon />} />
      <ModeButton mode='Rally Point' label='Rally Point' icon={<MyLocationIcon />} />
    </Stack>
  </Box>
);

export default observer(ToolsPanel);
